<div class="row">
  @if (section) {
    <div class="row-title group h-[34px] rounded px-2 gap-1 focus-within:[outline:1px_solid_var(--color-primary)]">
      <div class="row-title-icons">
        <app-button2 class="row-title-icon-btn" appearance="secondary-ghost" size="s" (click)="toggleCollapse()">
          <app-icon name="chevron-down" class="row-title-icon" [ngClass]="{ collapsed: collapsed }" />
        </app-button2>
      </div>

      <input
        #titleInput
        class="row-title-input font-medium leading-5 placeholder:text-secondary-600 text-secondary-700 [field-sizing:content] max-w-full w-auto outline-none px-3"
        (blur)="handleBlur()"
        (keydown.enter)="titleInput.blur()"
        placeholder="Section name"
        [formControl]="sectionForm.controls.title"
      />

      <div class="row-title-divider flex-1 h-px bg-secondary-300 self-center group-focus-within:opacity-0"></div>

      <app-button2
        class="column-collapse-dots rotate-90"
        appearance="secondary-ghost"
        size="s"
        matTooltip="More options"
        stchPopoverTrigger="click"
        [appSectionContextMenu]="section"
        [canMoveUp]="canMoveUp()"
        [canMoveDown]="canMoveDown()"
      >
        <app-icon name="sapphire-ellipsis" />
      </app-button2>
    </div>
  }

  <div
    class="row-collapseable-body"
    [ngClass]="{ collapsed: collapsed }"
    [@heightAnimation]="collapsed ? 'hide' : 'show'"
  >
    <div class="row-collapseable-body-content">
      @for (column of columns; track column.id; let i = $index) {
        @if (i > 0) {
          <div class="column-separator relative shrink-0 self-stretch w-[10px]">
            @if (!section) {
              <div
                class="absolute inset-y-0 left-1/2 -translate-x-1/2 z-[2] flex w-[28px] items-center justify-center opacity-0 hover:opacity-100 focus-within:opacity-100 transition-opacity duration-150"
              >
                <div class="absolute inset-y-0 left-1/2 -translate-x-1/2 w-[2px] rounded-[1px] bg-primary"></div>
                <app-button2
                  class="relative rounded-md border border-primary bg-white"
                  appearance="primary-ghost"
                  size="xs"
                  aria-label="Add column"
                  matTooltip="Add column"
                  (click)="insertColumnBefore(i)"
                >
                  <app-icon name="plus" />
                </app-button2>
              </div>
            }
          </div>
        }
        <app-project-board-column [appearance]="appearance" [column]="column" [section]="section" />
      }

      @if (!section && project?.id) {
        <button
          type="button"
          class="flex h-16 items-center self-start shrink-0 ml-[10px] mt-2 gap-1 rounded-[4px] px-2 text-secondary-600 cursor-pointer transition-colors hover:bg-gray-100 hover:text-gray-900"
          (click)="addColumn()"
        >
          <app-icon name="plus" size="l" />
          Add new column
        </button>
      }
    </div>
  </div>
</div>
